export default {
  nodeIp: '',
  userNode: 'planet-world.io',
  currencyNode: 'planet-world.io',
  queryRole: {
    accountId: 'test@planet-world.io',
    privateKey:
      '7e00405ece477bb6dd9b03a78eee4e708afc2f5bcdce399573a5958942f4a390'
  }
}
